export type ResourceSlug =
  | 'guide-securite-travail'
  | 'permis-de-feu'
  | 'plan-de-prevention'
  | 'checklist-conformite'
  | 'fiche-reflexe-crise'
  | 'trame-duerp'
  | 'scenario-exercice-incendie'

export interface Resource {
  slug: ResourceSlug
  /** Image d'aperçu statique, sous public/ */
  previewImage: string
  /** PDF téléchargeable statique, sous public/ */
  pdfPath: string
  /** Route TanStack (avec segment $locale) du tool/solution lié pour le CTA */
  relatedToolPath: string
}

const RELATED_TOOL: Record<ResourceSlug, string> = {
  'guide-securite-travail': '/$locale/tools/compliance-audit',
  'permis-de-feu': '/$locale/tools/compliance-audit',
  'plan-de-prevention': '/$locale/solutions/people-security',
  'checklist-conformite': '/$locale/tools/compliance-audit',
  'fiche-reflexe-crise': '/$locale/tools/ppms-audit',
  'trame-duerp': '/$locale/tools/compliance-audit',
  'scenario-exercice-incendie': '/$locale/tools/ppms-audit',
}

// Ordre = ordre d'affichage (lineup : phare en premier).
const SLUGS: readonly ResourceSlug[] = [
  'guide-securite-travail',
  'permis-de-feu',
  'plan-de-prevention',
  'checklist-conformite',
  'fiche-reflexe-crise',
  'trame-duerp',
  'scenario-exercice-incendie',
]

const RESOURCES: readonly Resource[] = SLUGS.map((slug) => ({
  slug,
  previewImage: `/ressources/${slug}-preview.webp`,
  pdfPath: `/ressources/${slug}.pdf`,
  relatedToolPath: RELATED_TOOL[slug],
}))

export type NavResourceGroup = 'templates' | 'guides'

// Colonne du menu Ressources du header. `null` = lead magnet d'article : page +
// PDF publics, mais volontairement absent du menu (il se gagne depuis
// l'article, pas depuis la nav).
const NAV_GROUP: Record<ResourceSlug, NavResourceGroup | null> = {
  'guide-securite-travail': 'guides',
  'permis-de-feu': 'templates',
  'plan-de-prevention': 'templates',
  'checklist-conformite': 'guides',
  'fiche-reflexe-crise': 'guides',
  'trame-duerp': 'templates',
  'scenario-exercice-incendie': null,
}

const NAV_GROUP_ORDER: readonly NavResourceGroup[] = ['templates', 'guides']

export function getAllResources(): readonly Resource[] {
  return RESOURCES
}

/** Colonnes du menu Ressources du header, chacune dans l'ordre du lineup. */
export function getNavResourceGroups(): readonly {
  key: NavResourceGroup
  resources: readonly Resource[]
}[] {
  return NAV_GROUP_ORDER.map((key) => ({
    key,
    resources: RESOURCES.filter((r) => NAV_GROUP[r.slug] === key),
  }))
}

export function getResource(slug: string): Resource | undefined {
  return RESOURCES.find((r) => r.slug === slug)
}
